import clsx from 'clsx'
import { Emoji } from 'emoji-mart-virtualized'
import { Link } from 'react-router-dom'

import { SearchEntityType } from '@tribeplatform/gql-client/types'
import { Avatar } from '@tribeplatform/react-ui-kit/Avatar'

import { SearchSubtitle } from './SearchSubtitle'
import { getSearchItemLink } from './utils'

export const SearchRowPreview = ({ row, category }) => {
  if (category?.entityType === SearchEntityType.MEMBER)
    return <Avatar size="md" src={row?.media?.url} />

  if (
    category?.entityType === SearchEntityType.SPACE ||
    category?.entityType === SearchEntityType.POST
  ) {
    const media = row?.in?.image?.__typename ? row?.in?.image : row?.media
    if (media?.__typename === 'Emoji')
      return (
        <div className="w-10 h-10 flex items-center justify-center">
          <Emoji size={32} native emoji={media?.text} />
        </div>
      )

    if (media?.__typename === 'Image')
      return <Avatar rounded="md" size="md" src={media?.url} />
  }

  return null
}

export const SearchRow = ({ row, category, spacing = 'md' }) => {
  // The space for the post is deleted
  if (category?.entityType === SearchEntityType.POST && !row?.in) return null

  return (
    <Link
      to={getSearchItemLink(row)}
      className={clsx(
        'flex items-center space-x-3',
        spacing === 'md' && 'px-6 py-5',
        spacing === 'sm' && 'px-2 py-2',
      )}
    >
      <div className="flex-shrink-0">
        <SearchRowPreview row={row} category={category} />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-basicSurface-900">{row.title}</p>
        <p className="text-basicSurface-500 truncate">
          <SearchSubtitle row={row} />
        </p>
      </div>
    </Link>
  )
}

export const SearchRowPage = ({ search, link, spacing = 'md' }) => {
  if (!search) return null

  return (
    <Link
      to={link}
      className={clsx(
        'flex items-center space-x-3',
        spacing === 'md' && 'px-6 py-5',
        spacing === 'sm' && 'px-2 py-2',
      )}
    >
      <div className="flex-1 min-w-0">
        <span className="text-basicSurface-900">{search}</span>
        <span className="text-basicSurface-500 truncate">
          &nbsp;&mdash; Search posts, members and more
        </span>
      </div>
    </Link>
  )
}
